(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kotlin-wrappers-kotlin-react-jsLegacy', 'kotlin-wrappers-kotlin-react-dom-jsLegacy', 'kvision-jsLegacy', 'react', 'jquery', 'jquery-kotlin-jsLegacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kotlin-wrappers-kotlin-react-jsLegacy'), require('kotlin-wrappers-kotlin-react-dom-jsLegacy'), require('kvision-jsLegacy'), require('react'), require('jquery'), require('jquery-kotlin-jsLegacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-react-jsLegacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-react-jsLegacy'.");
    }if (typeof this['kotlin-wrappers-kotlin-react-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-react-jsLegacy'. Its dependency 'kotlin-wrappers-kotlin-react-jsLegacy' was not found. Please, check whether 'kotlin-wrappers-kotlin-react-jsLegacy' is loaded prior to 'kvision-kvision-react-jsLegacy'.");
    }if (typeof this['kotlin-wrappers-kotlin-react-dom-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-react-jsLegacy'. Its dependency 'kotlin-wrappers-kotlin-react-dom-jsLegacy' was not found. Please, check whether 'kotlin-wrappers-kotlin-react-dom-jsLegacy' is loaded prior to 'kvision-kvision-react-jsLegacy'.");
    }if (typeof this['kvision-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-react-jsLegacy'. Its dependency 'kvision-jsLegacy' was not found. Please, check whether 'kvision-jsLegacy' is loaded prior to 'kvision-kvision-react-jsLegacy'.");
    }if (typeof react === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-react-jsLegacy'. Its dependency 'react' was not found. Please, check whether 'react' is loaded prior to 'kvision-kvision-react-jsLegacy'.");
    }if (typeof jQuery === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-react-jsLegacy'. Its dependency 'jquery' was not found. Please, check whether 'jquery' is loaded prior to 'kvision-kvision-react-jsLegacy'.");
    }if (typeof this['jquery-kotlin-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-react-jsLegacy'. Its dependency 'jquery-kotlin-jsLegacy' was not found. Please, check whether 'jquery-kotlin-jsLegacy' is loaded prior to 'kvision-kvision-react-jsLegacy'.");
    }root['kvision-kvision-react-jsLegacy'] = factory(typeof this['kvision-kvision-react-jsLegacy'] === 'undefined' ? {} : this['kvision-kvision-react-jsLegacy'], kotlin, this['kotlin-wrappers-kotlin-react-jsLegacy'], this['kotlin-wrappers-kotlin-react-dom-jsLegacy'], this['kvision-jsLegacy'], react, jQuery, this['jquery-kotlin-jsLegacy']);
  }
}(this, function (_, Kotlin, $module$kotlin_wrappers_kotlin_react_jsLegacy, $module$kotlin_wrappers_kotlin_react_dom_jsLegacy, $module$kvision_jsLegacy, $module$react, $module$jquery, $module$jquery_kotlin_jsLegacy) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var Unit = Kotlin.kotlin.Unit;
  var throwCCE = Kotlin.throwCCE;
  var child = $module$kotlin_wrappers_kotlin_react_jsLegacy.react.child_9r8yuv$;
  var render = $module$kotlin_wrappers_kotlin_react_dom_jsLegacy.react.dom.render_2955dm$;
  var Widget = $module$kvision_jsLegacy.io.kvision.core.Widget;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var get_set = $module$kvision_jsLegacy.io.kvision.utils.get_set_5cw0du$;
  var emptySet = Kotlin.kotlin.collections.emptySet_287e2$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_287e2$;
  var functionalComponent = $module$kotlin_wrappers_kotlin_react_jsLegacy.react.functionalComponent_7g4vsr$;
  var createRef = $module$react.createRef;
  var ensureNotNull = Kotlin.ensureNotNull;
  var ContainerType = $module$kvision_jsLegacy.io.kvision.panel.ContainerType;
  var Root_init = $module$kvision_jsLegacy.io.kvision.panel.Root_init_39w7fw$;
  var useEffectWithCleanup = $module$kotlin_wrappers_kotlin_react_jsLegacy.react.useEffectWithCleanup_y10uuc$;
  var Any = Object;
  var attributesMapOf = $module$kotlin_wrappers_kotlin_react_dom_jsLegacy.$$importsForInline$$['kotlinx-html-js'].kotlinx.html.attributesMapOf_jyasbz$;
  var DIV_init = $module$kotlin_wrappers_kotlin_react_dom_jsLegacy.$$importsForInline$$['kotlinx-html-js'].kotlinx.html.DIV;
  var RDOMBuilder_init = $module$kotlin_wrappers_kotlin_react_dom_jsLegacy.react.dom.RDOMBuilder;
  var kVManagerReactInit;
  function KVManagerReact() {
    KVManagerReact_instance = this;
    this.reactDom_8be2vx$ = require('react-dom');
  }
  KVManagerReact.prototype.init_8be2vx$ = function () {
  };
  KVManagerReact.$metadata$ = {kind: Kind_OBJECT, simpleName: 'KVManagerReact', interfaces: []};
  var KVManagerReact_instance = null;
  function KVManagerReact_getInstance() {
    if (KVManagerReact_instance === null) {
      new KVManagerReact();
    }return KVManagerReact_instance;
  }
  function div$lambda(closure$classes) {
    return function (it) {
      return new DIV_init(attributesMapOf('class', closure$classes), it);
    };
  }
  function kvisionWrapper$lambda$lambda$lambda(closure$root, closure$el) {
    return function () {
      var tmp$, tmp$_0;
      (tmp$ = closure$root.v) != null ? (tmp$.dispose(), Unit) : null;
      if ((tmp$_0 = closure$el.v) != null) {
        $module$jquery(tmp$_0).remove();
      }return Unit;
    };
  }
  function kvisionWrapper$lambda$lambda(closure$elRef, closure$builder) {
    return function () {
      var tmp$;
      var root = {v: null};
      var el = {v: null};
      if ((tmp$ = closure$elRef.current) != null) {
        var closure$builder_0 = closure$builder;
        var tmp$_0;
        el.v = Kotlin.isType(tmp$_0 = document.createElement('div'), HTMLElement) ? tmp$_0 : throwCCE();
        tmp$.appendChild(ensureNotNull(el.v));
        root.v = Root_init(ensureNotNull(el.v), ContainerType.NONE, false, closure$builder_0);
      }return kvisionWrapper$lambda$lambda$lambda(root, el);
    };
  }
  function kvisionWrapper$lambda(closure$builder) {
    return function ($receiver, it) {
      var elRef = createRef();
      useEffectWithCleanup(void 0, kvisionWrapper$lambda$lambda(elRef, closure$builder));
      var $receiver_0 = new RDOMBuilder_init(div$lambda(null));
      $receiver_0.ref = elRef;
      $receiver.child_52psg1$($receiver_0.create());
      return Unit;
    };
  }
  function kvisionWrapper(builder) {
    return functionalComponent(void 0, kvisionWrapper$lambda(builder));
  }
  function kv($receiver, builder) {
    return child($receiver, kvisionWrapper(builder));
  }
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  Object.defineProperty(package$kvision, 'KVManagerReact', {get: KVManagerReact_getInstance});
  var package$react = package$kvision.react || (package$kvision.react = {});
  $$importsForInline$$['kotlin-wrappers-kotlin-react-jsLegacy'] = $module$kotlin_wrappers_kotlin_react_jsLegacy;
  $$importsForInline$$['kotlin-wrappers-kotlin-react-dom-jsLegacy'] = $module$kotlin_wrappers_kotlin_react_dom_jsLegacy;
  package$react.kvisionWrapper_t5svx8$ = kvisionWrapper;
  package$react.kv_i7m45p$ = kv;
  kVManagerReactInit = KVManagerReact_getInstance().init_8be2vx$();
  return _;
}));

//# sourceMappingURL=kvision-kvision-react-jsLegacy.js.map
